import { CardFooterItem } from "$components/card";
import { FormattedDate } from "$components/date/formatted-date";
import { FormattedMessage } from "react-intl";

type Props = {
  dispensedBy?: string;
  dispensedAt: string;
};

const DispensedPrescriptionFooterItems: FC<Props> = ({
  dispensedBy,
  dispensedAt,
}) => (
  <>
    <CardFooterItem
      label={
        <FormattedMessage
          id="patient.history.prescription.dispensedOn"
          defaultMessage="Dispensed:"
        />
      }
    >
      <FormattedDate value={dispensedAt} />
    </CardFooterItem>
    {dispensedBy && (
      <CardFooterItem
        label={
          <FormattedMessage
            id="patient.history.prescription.dispensedBy"
            defaultMessage="By:"
          />
        }
      >
        {dispensedBy}
      </CardFooterItem>
    )}
  </>
);

export { DispensedPrescriptionFooterItems };
